import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import base64 from "base-64";
import moment from "moment";

import api from "../../config/api";
import onboardingAction from "../../redux/onboarding/action";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import PageHead from "../../component/pageHead/PageHead";
import InputComp from "../../component/InputComp/InputComp";
import CustomButton from "../../component/CustomButton/CustomButton";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import { isNetworkRequestFailedError } from "../../config/helpers";

class Withdrawl extends Component {
  state = {
    amount: "",
    rsaPin: "",
    phoneNumber: "",
    transactionDate: moment().format("YYYY-MMMM-DD"),
  };

  componentDidMount() {
    const { history, setHistory, validateUser, user } = this.props;

    if (!validateUser.userName && user) {
      this.getValidationCredentials();
    }

    setHistory(history);
  }

  getValidationCredentials = async () => {
    const { getUser, setAlertMessage, user } = this.props;
    this.setState({ isLoading: true });

    try {
      const response = await api.getUsernameAndPassword(
        { userName: user.User.userName },
        user.token
      );
      const data = {
        userName: response.data.result.UserName,
        password: response.data.result.Password,
      };

      getUser(data);
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? this.getValidationCredentials
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  generateTransactionReference = async () => {
    const { user, validateUser, setAlertMessage } = this.props;
    const rsaPin = user.User.rsaPin;

    try {
      this.setState({ isLoading: true });

      const header = {
        Authorization:
          "Basic " +
          base64.encode(validateUser.userName + ":" + validateUser.password),
      };
      const response = await api.validation({ rsaPin }, header);

      this.setState({
        phoneNumber: response.phoneNumber,
        transactionRef: response.transactionRef,
      });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? this.generateTransactionReference
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  submit = async () => {
    const { user, validateUser, setAlertMessage } = this.props;
    const { amount, transactionDate, phoneNumber, transactionRef } = this.state;
    const rsaPin = user.User.rsaPin;

    const header = {
      Authorization:
        "Basic " +
        base64.encode(validateUser.userName + ":" + validateUser.password),
    };

    try {
      this.setState({ isLoading: true });

      const body = {
        amount,
        transactionRef: transactionRef,
        rsaPin,
        mobileNumber: phoneNumber,
        transactionDate: moment(transactionDate).toISOString(),
      };

      await api.withdrawal(body, header);

      setAlertMessage({ type: "success", message: "Successful!" });
      this.setState({ disableBtn: true });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.submit : null,
      });
    }

    this.setState({
      isLoading: false,
      amount: "",
      phoneNumber: "",
      transactionRef: "",
    });
  };

  render() {
    const { user } = this.props;
    const { amount, phoneNumber, transactionDate, transactionRef, isLoading } =
      this.state;

    return (
      <Container>
        <PageHead title="WITHDRAWAL" containerStyles={{ width: "100%" }} />
        <InputComp
          type="text"
          name="rsaPin"
          value={user.User.rsaPin}
          placeholder="RSA PIN"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            this.setState({ rsaPin: e.target.value });
          }}
          disabled={true}
        />
        <InputComp
          type="text"
          name="mobileNum"
          value={phoneNumber}
          placeholder="Mobile Number"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            this.setState({ mobileNumber: e.target.value });
          }}
          disabled={true}
        />
        <InputComp
          type="text"
          name="transactionDate"
          value={transactionDate}
          placeholder="Transaction Date"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            this.setState({ transactionDate: e.target.value });
          }}
          disabled={true}
        />

        <InputComp
          type="text"
          name="transactionRef"
          value={transactionRef}
          placeholder="Transaction Reference"
          containerStyles={{ width: "100%" }}
          disabled={true}
        />

        <Row className="my-2 justify-content-center">
          <Col className="p-0" sm={5} md={4}>
            <CustomButton
              buttonText="Generate Transaction Reference"
              buttonClasses="btn-block"
              onClick={this.generateTransactionReference}
            />
          </Col>
        </Row>

        <InputComp
          type="text"
          name="amount"
          value={amount}
          placeholder="Amount"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            this.setState({ amount: e.target.value });
          }}
        />
        <Row className="my-2 justify-content-center">
          <Col className="p-0" sm={5} md={3}>
            <CustomButton
              buttonText="Submit"
              buttonClasses="btn-block"
              onClick={this.submit}
              disabled={!transactionRef}
            />
          </Col>
        </Row>
        {isLoading && <CustomLoader text="Please wait" />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  validateUser: state.onboarding.user,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
  getUser: onboardingAction.getUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(Withdrawl);
